import { Controller } from '@hotwired/stimulus';
import { throttle } from 'throttle-debounce';

export default class extends Controller {
	static targets = ['navigationContainer', 'navigation', 'subMenu'];

	connect() {
		// safari logo width fix
		const img = document.querySelector('.mobile-logo');
		if(img != null) {
			const imgWidth = img.width;
			img.parentElement.style.maxWidth = `${imgWidth}px`;
		}
	}

	initialize() {
		this.oldScrollValue = 0;
	}

	toggle() {
		if (this.navigationTarget.hasAttribute('data-group-active')) {
			this.navigationTarget.removeAttribute('data-group-active');
			this.subMenuTargets.forEach((subMenu) => {
				subMenu.removeAttribute('data-active');
			});
			document.querySelector('html').classList.remove('overflow-y-hidden');

			// If banner active remove the height so the menu shows correct
			if (document.getElementById('banner')) {
				document.getElementById('banner').classList.remove('!max-h-0');
			}
		} else {
			this.navigationTarget.setAttribute('data-group-active', true);
			document.querySelector('html').classList.add('overflow-y-hidden');

			// If banner active remove the height so the menu shows correct
			if (document.getElementById('banner')) {
				document.getElementById('banner').classList.add('!max-h-0');
			}
		}
	}
	openSubMenu(e) {
		e.preventDefault();

		const subMenu = e.currentTarget
			.closest('[data-navigation-mobile-target="subMenuContainer"]')
			.querySelector('[data-navigation-mobile-target="subMenu"]');

		subMenu.setAttribute('data-active', true);
	}
}
